<template>
  <div>
    <van-swipe
      v-if="swipeShow"
      :autoplay="config.duration>=0 ? config.duration : 3000"
      :show-indicators="true"
      indicator-color="white"
    >
      <van-swipe-item
        v-for="item in topSwipeData.items"
        :key="item.objectType + item.objectId"
        @click="clickItem(item.objectType, item.objectId)"
      >
        <top-swipe-item
          :slug="slug"
          :item="item"
        ></top-swipe-item>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
  import { Swipe, SwipeItem } from 'vant'
  import TopSwipeItem from './top-swipe-item.vue'
  import Vue from 'vue'
  Vue.use(Swipe, SwipeItem)

  export default {
    name: "TopSwipe",
    components: {
      TopSwipeItem
    },
    data () {
      return {
        slug: '', // show 的 slug
        config: {}, // 设置
        swipeShow: true,
        topSwipeData: {}
      }
    },
    methods: {
      getTopSwipeConfig: function () {
        let that = this
        let params = {
          show__slug: that.slug
        }
        that.$api.topSwipeConfig.list(params).then(res => {
          // window.console.log("获取到 topSwipe config")
          // window.console.log(res)
          if (res.data.count > 0) {
            if (res.data.results[0].enable) {
              // window.console.log("TopSwipe区块已启用")
              that.getTopSwipe()
              that.config = res.data.results[0]
            } else {
              window.console.log("TopSwipe区块已禁用")
            }
          } else {
            window.console.log("未找到相关配置")
          }
        })
      },
      getTopSwipe: function () {
        let that = this
        let params = {
          slug: that.slug,
          hidden: false
        }
        that.$api.topSwipe.list(params).then(res => {
          if (res.data.results.length > 0) {
            that.topSwipeData = res.data.results[0]
          }
          // window.console.log("获取到未隐藏的 TopSwipe 列表")
          // window.console.log(res)
          // that.items = res.data.results
        })
      },
      clickItem: function (objectType, objectId) {
        switch (objectType) {
          case 'episode':
            this.$router.replace({
              name: 'EpisodeDetail',
              params: {
                episodeId: objectId
              }
            })
            break
          case 'topic':
            this.$router.replace({
              name: 'TopicDetail',
              params: {
                topicId: objectId
              }
            })
            break
          default:
            break
        }
      }
    },
    watch: {
      // 横向跑马灯有一个 bug
      // 切到别的页面再切回来就会不显示
      // 这里监听切换状态，再重新显示此区块可规避此 bug
      $route(to, from){
        if (from != to && from.name == 'Discovery') {
          this.swipeShow = false
        }
        if (to != from && to.name == 'Discovery') {
          this.swipeShow = true
        }
      }
    },
    mounted () {
      this.slug = this.$route.params.slug
      this.getTopSwipeConfig()
      // window.console.log("组件被加载")
    },
    destroyed () {
      // window.console.log("组件被销毁")
    }
  }
</script>

<style lang="css" scoped>
</style>
